import { jsx as _jsx } from "react/jsx-runtime";
import { AdsProvider } from "@/ads/context";
import { brandConfiguration } from "@/brands/config";
import { CDP_INITIATIVE } from "@/constants";
import { AuthProvider } from "@/contexts/auth";
import { CallTrackingProvider } from "@/contexts/callTracking";
import { CdpConfigProvider } from "@/contexts/cdpConfig";
import { ClassifiedProvider } from "@/contexts/classified";
import { ConfirmationPageProvider } from "@/contexts/confirmPage";
import { ContactProvider } from "@/contexts/contact";
import { RefsProvider } from "@/contexts/ref";
import { GalleryProvider } from "@/gallery/contexts";
import { BrandProvider } from "@/shared/contexts";
import { FavoritesProvider } from "@seeker-consumer-portal/favorite-heart";
import { useEffect } from "react";
import { GDPRProvider } from "./GDPR";
export let featureFlagsTracking;
export let featureFlags;
export const CdpProvider = ({ children, config, classified, error, }) => {
    const { env } = config || {};
    const locale = config === null || config === void 0 ? void 0 : config.locale;
    const brand = config === null || config === void 0 ? void 0 : config.brand;
    featureFlagsTracking = classified === null || classified === void 0 ? void 0 : classified.featureFlagsTracking;
    featureFlags = classified === null || classified === void 0 ? void 0 : classified.featureFlags;
    useEffect(() => {
        window["pageProps"] = { config, classified, error };
    });
    return (_jsx(CdpConfigProvider, { value: config, children: _jsx(ClassifiedProvider, { value: classified, children: _jsx(AuthProvider, { oauthBaseUrl: config.oauthBaseUrl, children: _jsx(BrandProvider, { config: brandConfiguration, children: _jsx(ConfirmationPageProvider, { children: _jsx(GDPRProvider, { children: _jsx(ContactProvider, { crsBaseUrl: config.crsBaseUrl, contactSections: classified === null || classified === void 0 ? void 0 : classified.contactSections, children: _jsx(RefsProvider, { children: _jsx(CallTrackingProvider, { children: _jsx(FavoritesProvider, { env: env, 
                                            // @ts-ignore we need to update the FavoritesProvider to accept LOGICIMMO
                                            brand: brand, locale: locale, category: "classified_detail", initiative: CDP_INITIATIVE, children: _jsx(GalleryProvider, { children: _jsx(AdsProvider, { bffData: classified === null || classified === void 0 ? void 0 : classified.advertising, children: children }) }) }) }) }) }) }) }) }) }) }) }));
};
